
import {throwError as observableThrowError,  Observable } from 'rxjs';

import {catchError, map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HeaderBarLinkResource } from "app/models/HeaderBarLinkResource";
import { UtilsService } from "app/services/utils.service";
import { TokenInterceptor } from "app/authorized-http.service";
import { Http, Response } from '@angular/http';
import { HeaderBarLinkListResource } from "app/models/HeaderBarLinkListResource";
import { HeaderBodyResource } from "app/models/HeaderBodyResource";
import { HeaderConfigurationResource } from "app/models/HeaderConfigurationResource";
import { HttpClient } from "@angular/common/http";
import { environment } from "app/baseUrl";

@Injectable()
export class HeaderService {

  constructor(private http: HttpClient, private httpa: TokenInterceptor, private utilsService: UtilsService) { }

  saveHeaderBarLink(url, body): Observable<HeaderBarLinkResource> {
    return this.http.post<HeaderBarLinkResource>(environment['url'] + url, body)
  }

  getHeaderBarLinks(url): Observable<HeaderBarLinkListResource> {
    return this.http.get<HeaderBarLinkListResource>(environment['url'] + url)
  }

  deleteLink(url): Observable<HeaderBarLinkResource> {
    return this.http.get<HeaderBarLinkResource>(environment['url'] + url)
  }

  saveHeaderBody(url, body): Observable<HeaderBodyResource> {
    return this.http.post<HeaderBodyResource>(environment['url'] + url, body)
  }

  getHeaderBody(url): Observable<HeaderBodyResource> {
    return this.http.get<HeaderBodyResource>(environment['url'] + url)
  }

  saveHeaderStyleConfig(url, body): Observable<HeaderConfigurationResource> {
    return this.http.post<HeaderConfigurationResource>(environment['url'] + url, body)
  }

  getHeaderStyleConfig(url): Observable<HeaderConfigurationResource> {
    return this.http.get<HeaderConfigurationResource>(environment['url'] + url)
  }

}
